if (!customElements.get('poshtik-collection-card')) {
  customElements.define('poshtik-collection-card', class extends HTMLElement {
    connectedCallback() {
      const select = this.querySelector('select[name="id"]');
      const price = this.querySelector('[data-card-price]');
      const button = this.querySelector('button[type="submit"]');
      select?.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        if (price && option.dataset.price) price.textContent = option.dataset.price;
        if (button) {
          const available = option.dataset.available === 'true';
          button.disabled = !available;
          const label = button.querySelector('span');
          if (label) label.textContent = available ? button.dataset.availableLabel : button.dataset.soldOutLabel;
        }
      });
    }
  });
}

if (!customElements.get('poshtik-outcome-filter')) {
  customElements.define('poshtik-outcome-filter', class extends HTMLElement {
    connectedCallback() {
      this.sort = this.querySelector('[data-poshtik-sort]');
      this.sort?.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', this.sort.value);
        window.location.assign(url.toString());
      });

      this.addEventListener('click', (event) => {
        const button = event.target.closest('button[data-outcome]');
        if (!button) return;
        this.applyOutcome(button.dataset.outcome, true);
      });

      const requestedOutcome = new URLSearchParams(window.location.search).get('need');
      const initialButton = requestedOutcome && this.querySelector(`button[data-outcome="${CSS.escape(requestedOutcome.toLowerCase())}"]`);
      if (initialButton) this.applyOutcome(initialButton.dataset.outcome, false);

      const gridContainer = document.querySelector('#ProductGridContainer');
      if (gridContainer) {
        this.observer = new MutationObserver((mutations) => {
          const gridChanged = mutations.some((mutation) =>
            [...mutation.addedNodes].some((node) =>
              node.nodeType === Node.ELEMENT_NODE &&
              (node.matches?.('#product-grid, #product-grid > li') || node.querySelector?.('#product-grid'))
            )
          );
          if (!gridChanged) return;
          const active = this.querySelector('button.is-active[data-outcome]');
          if (active) this.applyOutcome(active.dataset.outcome, false);
        });
        this.observer.observe(gridContainer, { childList: true, subtree: true });
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    applyOutcome(value, updateUrl) {
        const outcome = (value || 'all').toLowerCase();
        const button = this.querySelector(`button[data-outcome="${CSS.escape(outcome)}"]`);
        this.querySelectorAll('button[data-outcome]').forEach((item) => item.classList.toggle('is-active', item === button));
        const cards = document.querySelectorAll('#product-grid > li');
        let visible = 0;
        cards.forEach((item) => {
          const card = item.querySelector('poshtik-collection-card');
          const match = outcome === 'all' || card?.dataset.need?.includes(outcome);
          item.hidden = !match;
          if (match) visible += 1;
        });
        const count = document.querySelector('[data-poshtik-result-count]');
        if (count) {
          const resultCount = outcome === 'all' ? count.dataset.totalCount || visible : visible;
          count.textContent = `${resultCount} products`;
        }
        document.querySelector('[data-poshtik-empty]')?.toggleAttribute('hidden', visible !== 0);

        if (updateUrl) {
          const url = new URL(window.location.href);
          if (outcome === 'all') url.searchParams.delete('need');
          else url.searchParams.set('need', outcome);
          window.history.replaceState({}, '', url);
        }
    }
  });
}
